import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEnterpriseProjectManagementService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-enterprise-project-management-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 5.62V8h1.52V4.76H8V3.24H3.24zM16 4v.76h3.24V8h1.52V3.24H16zm-4.405 1.282c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4 4 0 0 0 0 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092s1.912-.362 2.642-1.092S15.734 10.036 15.734 9c0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58s-.205 1.126-.659 1.58c-.456.456-.944.66-1.58.66s-1.124-.204-1.58-.66c-.454-.454-.659-.945-.659-1.58s.205-1.126.659-1.58q.466-.465 1.005-.597a2.9 2.9 0 0 1 1.131-.001m-5.685 9.083-1.39 1.344.502.525c.276.289.517.526.535.526s.55-.5 1.18-1.11l1.146-1.11 3.368.001 3.368.001 1.152 1.126 1.153 1.125.241-.237c.132-.13.365-.374.518-.542l.277-.306-1.379-1.344-1.38-1.344H8.26zM3.24 18.38v2.38H8v-1.52H4.76V16H3.24zm16-.76v1.62H16v1.52h4.76V16h-1.52z"
    })
  }));
});
export default SvgEnterpriseProjectManagementService;